<template>
    <q-card class="bg-primary text-white column">
        <q-toolbar>
            <q-btn class="q-mr-xs" label="Save" size="sm" text-color="black" icon="save" color="white"
                @click="setDecoder" />
            <q-space />
            <q-btn flat round dense icon="close" v-close-popup />
        </q-toolbar>

        <q-card-section class="col q-pt-none">
            <CodeEditor v-model="decoder" width="100%" height="350px" font-size="10px" theme="nnfx-dark">
            </CodeEditor>
            <q-input class="q-pt-sm" bg-color="grey-2" dense filled v-model="input" label="Input">
                <template v-slot:hint>
                    Input
                </template>
                <template v-slot:after>
                    <q-btn color="grey-2" round dense flat icon="send" @click="runTest" />
                </template>
            </q-input>
        </q-card-section>

    </q-card>
    <q-dialog v-model="show_result" position="bottom">
        <q-card style="width: 350px">
            <q-card-section class="row items-center no-wrap">
                    <pre>{{ result }}</pre>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>
  
<style></style>
  
<script>
import CodeEditor from 'simple-code-editor';

export default {
    name: 'TestSerialDecoder',
    components: {
        CodeEditor,
    },
    data() {
        return {
            decoder: "",
            input: "",
            result: "",
            show_result: false,
        }
    },
    methods: {
        runTest() {
            var wrap = () => "{ return " + this.decoder + " };"
            var func = new Function(wrap());
            let result = func.call(null).call(null, this.input);
            this.result = JSON.stringify(result, null, 2);
            this.show_result = true;
        },
        setDecoder() {
            this.$store.commit('setDecoder', this.decoder);
        },
    },
    mounted() {
        this.decoder = this.$store.state.serial.decoder;
    },
}
</script>
  